module.exports = __webpack_public_path__ + "img/P150T_weapon_58.17b4ae20.png";